module.exports = __webpack_public_path__ + "img/keyboard_SaitenInputModeArea.60a12d9c.png";